import React from "react";
import { css, cx } from "../../../styled-system/css";

type SectionPadding = "none" | "small" | "medium" | "large";
type SectionInnerSpacing = "none" | "small";

export interface ModuleSectionGroupProps {
  children: React.ReactNode;
  paddingTop?: SectionPadding;
  paddingBottom?: SectionPadding;
  innerSpacing?: SectionInnerSpacing;
}

const paddingTopStyles: Record<SectionPadding, string> = {
  none: css({ paddingTop: "0", desktop: { paddingTop: "0" } }),
  small: css({ paddingTop: "32px", desktop: { paddingTop: "32px" } }),
  medium: css({ paddingTop: "24px", desktop: { paddingTop: "36px" } }),
  large: css({ paddingTop: "48px", desktop: { paddingTop: "72px" } }),
};

const paddingBottomStyles: Record<SectionPadding, string> = {
  none: css({ paddingBottom: "0", desktop: { paddingBottom: "0" } }),
  small: css({ paddingBottom: "32px", desktop: { paddingBottom: "32px" } }),
  medium: css({ paddingBottom: "24px", desktop: { paddingBottom: "36px" } }),
  large: css({ paddingBottom: "48px", desktop: { paddingBottom: "72px" } }),
};

const innerSpacingStyles: Record<SectionInnerSpacing, string> = {
  none: css({ gap: "0" }),
  small: css({ gap: "32px" }),
};

export const ModuleSectionGroup = ({
  children,
  paddingTop = "medium",
  paddingBottom = "medium",
  innerSpacing = "none",
}: ModuleSectionGroupProps) => {
  return (
    <div
      className={cx(
        css({ display: "flex", flexDirection: "column", "& > *": { width: "100%" } }),
        paddingTopStyles[paddingTop],
        paddingBottomStyles[paddingBottom],
        innerSpacingStyles[innerSpacing],
      )}
    >
      {children}
    </div>
  );
};
